import PropTypes from 'prop-types'
import React from 'react'

import ButtonInbox from 'components/ButtonInbox/ButtonInbox'

import { APPLICATIONS_AND_INVITES } from './translations'

import styles from './Inbox.scss'

class Inbox extends React.PureComponent {
    static propTypes = {
        messages: PropTypes.number,
        onClick: PropTypes.func.isRequired,
    }

    render() {
        return (
            <div className={styles.inbox}>
                <div className={styles.inboxCaption}>
                    {APPLICATIONS_AND_INVITES}
                </div>
                <div className={styles.inboxButton}>
                    <ButtonInbox
                        messages={this.props.messages}
                        onClick={this.props.onClick}
                        type='miniSecondary'
                    />
                </div>
            </div>
        )
    }
}

export default Inbox



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/Inbox/Inbox.js